<template>
	<div class="chat-moment-msg-box">
		<div class="chat-moment-msg-nav">
			<span class="chat-moment-msg-nav-back" @click="goBack"></span>
			<span class="chat-moment-msg-nav-title">最新朋友圈消息</span>
		</div>
		<div class="chat-moment-msg-wrap">
			<div class="chat-moment-msg-items">
				<div class="chat-moment-msg-item" v-for="msg in msgs" @click="goDetail(msg.moments,msg.customId)">
					<div class="chat-moment-msg-avatar">
						<img :src="msg.fans.wx_photo" alt="">
					</div>
					<div class="chat-moment-msg-detail" v-if="msg.isComment">
						<p class="chat-moment-msg-name">{{msg.comment.friendName}}</p>
						<p class="chat-moment-msg-relay">
							<span  v-html="$options.filters.formatMsg(msg.comment.content,'text')"></span>
						</p>
						<p class="chat-moment-msg-time">{{msg.comment.createTime | rechentDate}}</p>
					</div>
					<div class="chat-moment-msg-detail" v-else-if="msg.isZan">
						<p class="chat-moment-msg-name">{{msg.zan.friendName}}</p>
						<p class="chat-moment-msg-relay">
							<span class="chat-moment-msg-zan"></span>
						</p>
						<p class="chat-moment-msg-time">{{msg.zan.createTime | rechentDate}}</p>
					</div>
					<div class="chat-moment-msg-content">
						<div class="chat-moment-msg-text" v-if="msg.cover == ''">
							<span>{{msg.content}}</span>
						</div>
						<div class="chat-moment-msg-pic" v-else-if="msg.type === 1">
							<img :src="msg.cover" alt="">
						</div>
						<div class="chat-moment-msg-video"  v-else-if="msg.type === 2">
							<img :src="msg.cover" alt="">
							<span></span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'ChatMomentMsg',
		props:{
			msgList:{
				type: Array,
				default:function(){
					return []
				}
			}
		},
		data(){
			return {
				msgs:[]
			}
		},
		methods:{
			// 返回上一页
			goBack(){
				this.$emit('chat-m-msg-back',{
					type: 'basic',
					data: {}
				})
			},
			
			// 调整到详情页
			goDetail(data,customId){
				this.$emit('chat-m-msg-back',{
					type: 'info',
					data: data,
					customId:customId
				})
			},
			
			// 评论，点赞数据处理
			handleData(){
				let msgList = JSON.parse(JSON.stringify(this.msgList))
				let list = []
				for (let i = 0; i < msgList.length; i++) {
					if(msgList[i].moments === undefined && msgList[i].fansMoments === undefined){
						continue
					}
					let reply = {
						account_open_id: msgList[i].account_open_id,
						customId: msgList[i].customId,
						friendId: msgList[i].friendId,
						friends_open_id: msgList[i].friends_open_id,
						isComment: msgList[i].isComment,
						isZan: msgList[i].isZan,
						fans: msgList[i].fans
					}
					// 点赞和评论的处理
					if(reply.isComment){
						reply.comment = {
							accountCommentId: msgList[i].reply.accountCommentId,
							friendName: msgList[i].reply.friendName,
							friendOpenId: msgList[i].reply.friendOpenId,
							content: msgList[i].reply.content,
							createTime: msgList[i].reply.createTime,
							arguedOpenId: msgList[i].reply.arguedOpenId === undefined ? '' : msgList[i].reply.arguedOpenId,
							arguedName: msgList[i].reply.arguedName === undefined ? '' : msgList[i].reply.arguedName
						}
					}else{
						reply.zan = {
							accountCommentId: msgList[i].reply.accountCommentId,
							friendName: msgList[i].reply.friendName,
							friendOpenId: msgList[i].reply.friendOpenId,
							content: msgList[i].reply.content,
							createTime: msgList[i].reply.createTime
						}
					}
					let type = 1
					let cover = ''
					let content = ''
					// 朋友圈内容的处理
					if(msgList[i].commentMyself === 1 && msgList[i].moments !== undefined){
						let moments = {}
						switch(msgList[i].moments.type){
							case 1: 
								moments = this.handleCustomMDetail(msgList[i].moments,1)
								break
							case 3:
								moments = this.handleCustomMDetail(msgList[i].moments,2)
								break
							case 4:
								moments = this.handleCustomMDetail(msgList[i].moments,3)
								break
						}
						moments.commentMyself = 1
						reply.moments = moments
						type = moments.type
						content = moments.content
						if(moments.type === 1 && moments.pics.length > 0){
							cover =  moments.pics[0]
						}else if(moments.type === 2 && moments.video.videoPic !== ''){
							cover =   moments.video.videoPic
						}
					}
					// 粉丝的朋友圈
					else if(msgList[i].commentMyself === 0 && msgList[i].fansMoments !== undefined){
						let fansMoments = {}
						switch(msgList[i].fansMoments.type){
							case 1: 
								fansMoments = this.handleCustomMDetail(msgList[i].fansMoments,1)
								break
							case 2:
								fansMoments = this.handleCustomMDetail(msgList[i].fansMoments,1)
								break
							case 3:
								fansMoments = this.handleCustomMDetail(msgList[i].fansMoments,3)
								break
							case 4:
								fansMoments = this.handleCustomMDetail(msgList[i].fansMoments,4)
								break
							case 15:
								fansMoments = this.handleCustomMDetail(msgList[i].fansMoments,2)
								break
						}
						fansMoments.commentMyself = 0
						reply.moments = fansMoments
						type = fansMoments.type
						content = fansMoments.content
						if(fansMoments.type === 1 && fansMoments.pics.length > 0){
							cover =  fansMoments.pics[0]
						}else if(fansMoments.type === 2 && fansMoments.video.videoPic !== ''){
							cover =   fansMoments.video.videoPic
						}
					}
					reply.type = type
					reply.content = content
					reply.cover = cover
					list.push(reply)
				}
				this.msgs = list
			},
			
			// 根据类型处理客服自己的发的朋友圈
			handleCustomMDetail(data,type){
				let pics = []
				let video = {
					videoPic: '',
					videoUrl: ''
				}
				let link = {
					linkImg:'',
					linkText:'',
					url: ''
				}
				let music = {
					title:'',
					desc:'',
					url: ''
				}
				// 根据类型，处理图片，视频，链接等数据
				if(type == 1){
					if(data.imgUrl !== undefined && data.imgUrl !== ''){
						let picList = data.imgUrl.split(",")
						for (let i = 0; i < picList.length; i++) {
							pics.push(picList[i]+'?x-oss-process=image/auto-orient,1/resize,m_fill,w_150,h_150/quality,q_90')
						}
					}
				}else if(type == 2){
					if(data.imgUrl !== undefined && data.cover !== undefined){
						video = {
							videoPic: data.cover,
							videoUrl: data.imgUrl
						}
					}
				}else if(type == 3){
					link = {
						linkText:data.urlContent,
						linkImg: data.imgUrl,
						url: data.url
					}
				}
				return {
					pics: pics,
					video: video,
					link:link,
					music: music,
					type: type,
					content: data.content,
					openId: data.openId,
					snsid: data.snsid,
					time: data.time
				}
			}
		},
		created() {
			this.handleData()
		}
		
	}
</script>

<style>
	.chat-moment-msg-box{
		position: relative;
		height: 100%;
		width: 100%;
	}
	.chat-moment-msg-box .chat-moment-msg-nav{
		height: 30px;
		line-height: 30px;
		border-bottom: 1px solid #e3e3e3;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-moment-msg-nav > span{
		display: block;
	}
	.chat-moment-msg-nav .chat-moment-msg-nav-back{
		width: 40px;
		height: 30px;
		cursor: pointer;
		background-image: url(../assets/img/back-8a-32.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: auto 16px;
	}
	.chat-moment-msg-nav .chat-moment-msg-nav-title{
		flex-grow: 1;
		width: 0;
		text-align: center;
		color: #8a8a8a;
	}
	.chat-moment-msg-wrap{
		position: absolute;
		top: 31px;
		bottom: 0;
		width: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-moment-msg-items{
		padding: 0 20px;
	}
	.chat-moment-msg-items .chat-moment-msg-item{
		padding: 8px 0;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		cursor: pointer;
		border-bottom: 1px solid #efefef;
	}
	.chat-moment-msg-item:last-child{
		border-bottom: none;
	}
	.chat-moment-msg-item .chat-moment-msg-avatar{
		width: 40px;
		height: 40px;
		margin-right: 10px;
	}
	.chat-moment-msg-avatar img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.chat-moment-msg-item .chat-moment-msg-detail{
		min-height: 60px;
		line-height: 20px;
		flex-grow: 1;
		width: 0;
	}
	.chat-moment-msg-detail > p{
		min-height: 20px;
	}
	.chat-moment-msg-detail .chat-moment-msg-name{
		font-weight: bold;
		color: #225f8c;
	}
	.chat-moment-msg-detail .chat-moment-msg-relay{
		font-size: 12px;
	}
	.chat-moment-msg-relay > span{
		display: inline-block;
		vertical-align: middle;
	}
	.chat-moment-msg-relay .chat-moment-msg-zan{
		width: 20px;
		height: 20px;
		background-image: url(../assets/img/comp-m-zan.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: auto 16px;
	}
	.chat-moment-msg-detail .chat-moment-msg-time{
		font-size: 12px;
		color: #8A8A8A;
	}
	.chat-moment-msg-item .chat-moment-msg-content{
		width: 60px;
		height: 60px;
		margin-left: 10px;
	}
	.chat-moment-msg-content  img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.chat-moment-msg-content .chat-moment-msg-text{
		width: 100%;
		height: 100%;
		overflow: hidden;
		line-height: 18px;
		color: #8A8A8A;
		word-break: break-all;
		padding: 5px;
		box-sizing: border-box;
		background-color: #e6e6e6;
		font-size: 12px;
	}
	.chat-moment-msg-text span{
		display: inline-block;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.chat-moment-msg-content .chat-moment-msg-video{
		width: 60px;
		height: 60px;
		overflow: hidden;
		position: relative;
	}
	.chat-moment-msg-video span{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 20px;
		height: 20px;
		display: block;
		background-image: url(/img/video_play.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 20px auto;
	}
</style>
